// Material helpers
import { createTheme } from '@mui/material/styles';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';
const theme = createTheme({
  palette,
  components: overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
    modal: 2600,
  },
  typography: {
    ...typography,
  },
});

export default theme;
